import {PropsWithChildren, ReactNode, useEffect, useRef} from "react";
import {css} from "@panda/css";

import {noop} from "@pg-mono/nodash";
import {useUserDevice} from "@pg-mono/user-device";

import {zIndexes} from "../../features/km_app/constants/z_indexes";
import {BottomSheet, useBottomSheetState} from "../bottom_sheet";
import {Modal} from "../modal/Modal";

interface IProps extends PropsWithChildren {
    ariaLabel: string;
    dataTestId?: string;
    desktopLayoutClassName?: string;
    footer?: ReactNode;
    header?: ReactNode;
    isCloseDisabled?: boolean;
    isOpen: boolean;
    onClose: () => void;
    showCloseButton?: boolean;
    withMobileContentPadding?: boolean;
    zIndex?: number;
}

export const ResponsiveOverlay = (props: IProps) => {
    const {
        ariaLabel,
        children,
        dataTestId,
        desktopLayoutClassName,
        footer,
        header,
        isCloseDisabled = false,
        isOpen,
        onClose,
        showCloseButton = true,
        withMobileContentPadding = true,
        zIndex = zIndexes.listingModal
    } = props;

    const {isMobile} = useUserDevice();
    const {close, isClosing, isEntering, isOpen: isSheetOpen, open} = useBottomSheetState();
    const handleClose = isCloseDisabled ? noop : onClose;
    const canShowCloseButton = showCloseButton && !isCloseDisabled;

    const closeRef = useRef(close);
    const openRef = useRef(open);

    closeRef.current = close;
    openRef.current = open;

    useEffect(() => {
        if (!isMobile) return;

        if (isOpen) openRef.current();
        else closeRef.current();
    }, [isMobile, isOpen]);

    if (isMobile) {
        const isMobileOverlayVisible = isSheetOpen || isClosing;

        if (!isMobileOverlayVisible) return null;

        return (
            <BottomSheet
                ariaLabel={ariaLabel}
                dataTestId={dataTestId}
                footer={footer}
                header={header}
                isClosing={isClosing}
                isEntering={isEntering}
                onClose={handleClose}
                shouldCloseOnOverlayClick={!isCloseDisabled}
                showDivider={false}
                withSwipe={!isCloseDisabled}
                zIndex={zIndex}
            >
                {withMobileContentPadding ? <div className={mobileContentStyle}>{children}</div> : children}
            </BottomSheet>
        );
    }

    if (!isOpen) return null;

    return (
        <Modal dataTestId={dataTestId} isOpen onModalClose={handleClose} showCloseButton={canShowCloseButton} zIndex={zIndex}>
            <Modal.Layout.Empty className={desktopLayoutClassName}>{children}</Modal.Layout.Empty>
        </Modal>
    );
};

const mobileContentStyle = css({
    px: 2
});
import {PropsWithChildren, ReactNode, useEffect, useRef} from "react";
import {css} from "@panda/css";

import {noop} from "@pg-mono/nodash";
import {useUserDevice} from "@pg-mono/user-device";

import {zIndexes} from "../../features/km_app/constants/z_indexes";
import {BottomSheet, useBottomSheetState} from "../bottom_sheet";
import {Modal} from "../modal/Modal";

interface IProps extends PropsWithChildren {
    ariaLabel: string;
    dataTestId?: string;
    desktopLayoutClassName?: string;
    footer?: ReactNode;
    header?: ReactNode;
    isCloseDisabled?: boolean;
    isOpen: boolean;
    onClose: () => void;
    showCloseButton?: boolean;
    withMobileContentPadding?: boolean;
    zIndex?: number;
}

export const ResponsiveOverlay = (props: IProps) => {
    const {
        ariaLabel,
        children,
        dataTestId,
        desktopLayoutClassName,
        footer,
        header,
        isCloseDisabled = false,
        isOpen,
        onClose,
        showCloseButton = true,
        withMobileContentPadding = true,
        zIndex = zIndexes.listingModal
    } = props;

    const {isMobile} = useUserDevice();
    const {close, isClosing, isEntering, isOpen: isSheetOpen, open} = useBottomSheetState();
    const handleClose = isCloseDisabled ? noop : onClose;
    const canShowCloseButton = showCloseButton && !isCloseDisabled;

    const closeRef = useRef(close);
    const openRef = useRef(open);

    closeRef.current = close;
    openRef.current = open;

    useEffect(() => {
        if (!isMobile) return;

        if (isOpen) openRef.current();
        else closeRef.current();
    }, [isMobile, isOpen]);

    if (isMobile) {
        const isMobileOverlayVisible = isSheetOpen || isClosing;

        if (!isMobileOverlayVisible) return null;

        return (
            <BottomSheet
                ariaLabel={ariaLabel}
                dataTestId={dataTestId}
                footer={footer}
                header={header}
                isClosing={isClosing}
                isEntering={isEntering}
                onClose={handleClose}
                shouldCloseOnOverlayClick={!isCloseDisabled}
                showDivider={false}
                withSwipe={!isCloseDisabled}
                zIndex={zIndex}
            >
                {withMobileContentPadding ? <div className={mobileContentStyle}>{children}</div> : children}
            </BottomSheet>
        );
    }

    if (!isOpen) return null;

    return (
        <Modal dataTestId={dataTestId} isOpen onModalClose={handleClose} showCloseButton={canShowCloseButton} zIndex={zIndex}>
            <Modal.Layout.Empty className={desktopLayoutClassName}>{children}</Modal.Layout.Empty>
        </Modal>
    );
};

const mobileContentStyle = css({
    px: 2
});
